export function trigger() {
  const triggerNav = document.querySelector('.trigger-nav');
  if(triggerNav) {
    triggerNav.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('is-exhibitors-filter-active');
      if(!document.body.classList.contains('is-nav-active')){
        document.body.classList.add('is-nav-active');
      } else {
        document.body.classList.remove('is-nav-active');
      }
    });
  }

  const triggerFilterExhibitor = document.querySelector('.trigger-filter-exhibitor');
  if(triggerFilterExhibitor) {
    triggerFilterExhibitor.addEventListener('click', function(e) {
      e.preventDefault();
      document.body.classList.remove('is-nav-active');
      if(!document.body.classList.contains('is-exhibitors-filter-active')){
        document.body.classList.add('is-exhibitors-filter-active');
      } else {
        document.body.classList.remove('is-exhibitors-filter-active');
      }
    });
  }

  const triggerReset = document.querySelectorAll('.trigger-reset');
  if(triggerReset.length) {
    triggerReset.forEach((el) => {
      el.addEventListener('click', function(e) {
        e.preventDefault();
        document.body.classList.remove('is-nav-active', 'is-exhibitors-filter-active', 'is-drawer-active');
      });
    })
  }
}